import { useTranslation } from 'react-i18next';
import { ShareDeviceDialogBase } from './ShareDeviceDialogBase';

interface ShareDeviceDialogContentFloorMapProps {
  onClose: () => void;
  floorMapImageUrl: string;
}

export const ShareDeviceDialogContentFloorMap = ({
  onClose,
  floorMapImageUrl,
}: ShareDeviceDialogContentFloorMapProps) => {
  const { t } = useTranslation();

  return (
    <ShareDeviceDialogBase onClose={onClose} showCloseButton>
      {floorMapImageUrl ? (
        <div className="dialog__map-image">
          <img
            src={floorMapImageUrl}
            alt={t('shareDevice.complete.floorMapTitle')}
          />
        </div>
      ) : (
        <div className="dialog__text">
          <p className="dialog__text-line">
            {t('shareDevice.complete.floorMapTitle')}
          </p>
        </div>
      )}
    </ShareDeviceDialogBase>
  );
};
